import { pn } from "@compass/core";
import { DevExpressReport, renderReportColumn, renderReportSummary } from "components";
import { MatchReportActualYearly, ReportPropertyBase } from "generated/openApi";

export const ActualYearly = (props: { report: MatchReportActualYearly }) => {
  return (
    <DevExpressReport
      dataSource={props.report.rows}
      staticPageSize={20}
      exportFormats={["pdf", "excel", "csv"]}
      onExporting={() => {
        return {
          header: "Match Actual Yearly",
          filename: "MatchActualYearly",
          tenantName: props.report.tenantName,
          infoTuples: [
            ["Date From", props.report.dateFrom ? new Date(props.report.dateFrom).toDateString() : undefined],
            ["Date To", props.report.dateTo ? new Date(props.report.dateTo).toDateString() : undefined],
            ["Status", props.report.reviewName],
          ],
        };
      }}
    >
      {props.report.reportProperties?.map((property) =>
        renderReportColumn({
          property: property,
          propertyKey: pn<ReportPropertyBase>("propertyName"),
        })
      )}

      {renderReportSummary({
        properties: props.report.reportProperties,
        propertyKey: pn<ReportPropertyBase>("propertyName"),
      })}
    </DevExpressReport>
  );
};
